import { render, staticRenderFns } from "./Turmas.vue?vue&type=template&id=1730aa46&"
import script from "./Turmas.vue?vue&type=script&lang=js&"
export * from "./Turmas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports